// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0e42229d","455":"278e54a6","977":"df8f671e"}[chunkId] + ".chunk.js";
};